export default function (Alpine) {
    Alpine.data('disclosure', function (defaults = {}, scope = {}) {
        return {
            ...scope,

            expanded: false,
            id: null,
            triggerId: null,

            ...defaults,

            init() {
                this.id ??= this.$id('disclosure')
                this.triggerId ??= this.id + '-trigger'
            },

            open() {
                this.expanded = true
                this.$nextTick(() => {
                    this.$root.dispatchEvent(new CustomEvent('disclosure-opened'))
                })
            },

            close() {
                this.expanded = false
                this.$nextTick(() => {
                    this.$root.dispatchEvent(new CustomEvent('disclosure-closed'))
                })
            },

            toggle() {
                this.expanded = !this.expanded
                this.$nextTick(() => {
                    this.$root.dispatchEvent(new CustomEvent(this.expanded ? 'disclosure-opened' : 'disclosure-closed'))
                })
            },

            trigger: {
                ['x-bind:type']() {
                    return 'button'
                },

                ['x-bind:id']() {
                    return this.triggerId
                },

                ['x-on:click']() {
                    this.toggle()
                },

                ['x-on:keyup.space.prevent']() {
                    this.toggle()
                },

                ['x-bind:aria-expanded']() {
                    return this.expanded
                },

                ['x-bind:aria-controls']() {
                    return this.id
                },
            },

            target: {
                ['x-show']() {
                    return this.expanded
                },

                ['x-bind:id']() {
                    return this.id
                },

                ['x-bind:aria-labelledby']() {
                    return this.triggerId
                },
            },
        }
    })
}
